import { ExclamationCircleFilled } from '@ant-design/icons';
import { App, Avatar, Dropdown } from 'antd';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { Ellipsis, Users2 } from 'lucide-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getRoutes } from '../../constants/Routes';
import { deleteGroup } from '../../redux/actions/groups';
import AddMembers from '../AddMembers';
import CreateGroup from '../CreateGroup';
import { decodeId, encodeId } from '../../utils/secureId';

const GroupList = ({ groups }) => {
    const { modal } = App.useApp();
    const { groupId: group_id } = useParams();
    const groupId = group_id && decodeId(group_id);
    const navigate = useNavigate();
    const [open, setOpen] = useState(null);

    const handleNavigate = (group) => {
        const encodedId = encodeId(group?.id);
        navigate(getRoutes().groups_detail.route(encodedId));
    };


    const handleDelete = (id) => {
        modal.confirm({
            title: 'Are you sure you want to delete this group?',
            icon: <ExclamationCircleFilled />,
            content: 'This action cannot be undone.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            centered: true,
            onOk: () => deleteGroup(id),
        });
    };


    return (
        <div className="group-list">
            <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                style={{ overflow: 'hidden' }}
            >
                {groups?.length ? (
                    groups.map((group) => {
                        const menuItems = [
                            {
                                key: 'edit_group',
                                label: 'Edit Group',
                                onClick: (e) => {
                                    e.domEvent.stopPropagation();
                                    setOpen({
                                        data: group,
                                        isGroup: true
                                    });
                                },
                            },
                            {
                                key: 'add_member',
                                label: 'Add Member',
                                onClick: (e) => {
                                    e.domEvent.stopPropagation();
                                    setOpen({
                                        data: group,
                                        isMember: true
                                    });
                                },
                            },
                            {
                                key: 'delete_group',
                                label: 'Delete Group',
                                onClick: (e) => {
                                    e.domEvent.stopPropagation();
                                    handleDelete(group?.id);
                                },
                            }
                        ];

                        return (
                            <div
                                className={clsx('group-item', { active: Number(groupId) === group.id })}
                                title={group?.name}
                                onClick={() => handleNavigate(group)}
                                key={group.id}
                            >
                                <Avatar
                                    style={{
                                        background: 'gray',
                                    }}
                                    icon={<Users2 size={18} />}
                                />
                                <h3 className="name truncate">{group?.name}</h3>
                                <div className="right-container">
                                    <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                                        <div className="action-btn" onClick={(e) => e.stopPropagation()}>
                                            <Ellipsis size={18} />
                                        </div>
                                    </Dropdown>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="empty">No Data</p>
                )}
            </motion.div>

            {open?.isMember && <AddMembers open={open?.isMember} group={open?.data} onCancel={() => setOpen(null)} />}
            {open?.isGroup && <CreateGroup open={open?.isGroup} onCancel={() => setOpen(null)} data={open?.data} />}
        </div>
    );
};

export default GroupList;
